module.exports = __webpack_public_path__ + "static/Ahr_Weinregionen__13_-scaled-89ed4134696aac6a012d9b8d163600f2.jpg";